/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';
import { AuthParams } from '../models/AuthParams';

export class ConnectAwsOrganizationRequest {
  'authParams': AuthParams;
  /**
  * Organization display name in Eon.
  */
  'name': string;
  'state': AccountState;
  /**
  * The organization OUID.
  */
  'organizationOUId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "authParams",
      "baseName": "authParams",
      "type": "AuthParams",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "state",
      "baseName": "state",
      "type": "AccountState",
      "format": ""
    },
    {
      "name": "organizationOUId",
      "baseName": "organizationOUId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectAwsOrganizationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



